import { AiFillGithub } from "react-icons/ai";
import { BiBriefcase } from "react-icons/bi";
import { GoLocation } from "react-icons/go";
import { HiMail } from "react-icons/hi";
import { ImLinkedin } from "react-icons/im";
import { TypeAnimation } from "react-type-animation";
import { iZamanShahed } from "../../utilities/ImageImports";
import ConnectCard from "./ConnectCard";

const HeroSection = () => {
    return (
        <div className="shadow-xl backdrop-blur dark:bg-cDarkBG2/30 dark:text-cDarkText bg-white/20 border border-white/10 sm:rounded-[32px] rounded-[26px] p-5 xl:p-10 relative w-full select-none z-50 initial-opacity-animation">
            
            <div className="absolute -top-[105px] sm:-top-[175px] left-[50%] -translate-x-[50%]">
                <div className="bg-gradient-to-tr from-cyan-500 via-emerald-400 to-blue-500 p-[4px] rounded-full h-[190px] sm:h-[250px] w-[190px] sm:w-[250px]">
                    <img
                        src={iZamanShahed}
                        alt=""
                        className="h-full w-full object-cover rounded-full"
                    />
                </div>
            </div>

            <div className="w-full text-center font-thin uppercase sm:text-3xl text-2xl xl:pt-[50px] pt-20 dark:text-cDarkText text-gray-600">
                MD. Shaheduzzaman Shahed
            </div>

            <div className="text-left dark:text-cDarkText text-gray-700">
                <div className="flex items-center space-x-5 pt-2.5">
                    <BiBriefcase />
                    <TypeAnimation
                        sequence={[
                            "Software Engineer", // Types 'One'
                            2000, // Waits 2s
                            "Web Developer",
                            2000, // Waits 2s
                            "React.js",
                            1000, // Waits 2s
                            "Next.js",
                            1000, // Waits 2s
                            "WebRTC",
                            1000, // Waits 2s
                            "Socket.io",
                            1000, // Waits 2s
                            "Node.js",
                            1000, // Waits 2s
                            "Laravel",
                            1000, // Waits 2s
                            "Linux Enthusiast",
                            2000, // Waits 2s
                            "Passionate for Terminal",
                            2000, // Waits 2s
                            () => {
                                // console.log('Thanks for checking out! peace..'); // Place optional callbacks anywhere in the array
                            },
                        ]}
                        wrapper="div"
                        cursor={true}
                        repeat={Infinity}
                        style={{ fontSize: "16px" }}
                    />
                </div>

                <div className="flex items-center space-x-5 pt-2.5">
                    <GoLocation />
                    <div>Dhaka, Bangladesh</div>
                </div>

                <div className="pt-5 text-justify text-sm md:text-base font-normal dark:text-cDarkText text-gray-500">
                    Results-driven Frontend Engineer with 4.5+ years of
                    experience building scalable, production-grade applications
                    using React.js, Next.js, and the modern frontend ecosystem.
                    Skilled in delivering optimized UIs, developing reusable
                    component systems, and ensuring seamless API integrations.
                    Adept at performance tuning, cross-team collaboration, and
                    shipping reliable solutions across web and mobile platforms.
                </div>

                <div className="flex justify-center pt-5 drop-shadow-md">
                    <div className="dark:text-teal-300 text-teal-400 px-5 py-0.5 rounded-full font-semibold">
                        Get in touch
                    </div>
                </div>
                <div className="flex items-center justify-center space-x-8 w-full px-5 md:px-10 lg:px-20 xl:px-40 pt-2.5 dark:text-gray-200 text-teal-400 drop-shadow-lg">
                    <ConnectCard
                        icon={<AiFillGithub />}
                        link="https://github.com/zamanshahed"
                        label="Github"
                    />

                    <ConnectCard
                        icon={<HiMail />}
                        link="mailto:sumonshd@gmail.com"
                        label="Email"
                    />
                    <ConnectCard
                        icon={<ImLinkedin />}
                        link="https://www.linkedin.com/in/zamanshahed/"
                        label="Linkedin"
                    />
                </div>
            </div>
        </div>
    );
};

export default HeroSection;
